import React from 'react'
import Button from '../components/Button'

function unique(a) {
  var seen = {}
  var uniques = []
  var i = 0
  a.forEach(e => {
    if (seen[e] !== 1) {
      seen[e] = 1
      uniques[i++] = e
    }
  })
  return uniques
}

function list(list, and) {
  return list.map((c, i) => {
    if (i !== list.length - 1 && i !== list.length - 2) {
      return (
        <span key={i}>
          <strong>{c}</strong>
          {', '}
        </span>
      )
    } else if (i === list.length - 1) {
      return <strong key={i}>{c}</strong>
    } else {
      return (
        <span key={i}>
          <strong>{c}</strong>
          {and}
        </span>
      )
    }
  })
}

class SummaryPage extends React.Component {
  constructor() {
    super()
    this.state = {
      selected: 0,
    }
  }

  static defaultProps = {
    setWrapperState: () => {},
  }

  onNext() {
    var nextPage = this.props.data.nextPageIndex
    if (typeof nextPage === 'object') {
      nextPage = nextPage[this.state.selected - 1]
    }
    const toUpdate = this.props.data.propUpdated
      ? this.props.data.propUpdated
      : 'temp'
    this.setState({ selected: 0 })
    this.props.setWrapperState({
      currPage: nextPage,
      [toUpdate]: this.state.selected,
    })
  }

  render() {
    const { data, wrapperState } = this.props
    return (
      <div>
        <h1>{data.header}</h1>
        <span className="summaryText">
          <div className="summaryResult">
          {data.summary[0]}
          <strong>
            {data.ages[wrapperState.age - 1] +
              ' ' +
              data.genders[wrapperState.gender - 1]}
          </strong>
          {data.summary[1]}
          <strong>{data.skinTypes[wrapperState.skinType - 1]}</strong>
          {data.summary[2]}
          {list(wrapperState.conditions, data.and)}.
          </div>
          <h3>{data.summaryConclusion}</h3>
        </span>
        {unique(wrapperState.selectedTreatments).map((t, i) => {
          const { content, link, title, titleLower} = data.treatments.find(
            dt => dt.treatmentID === t
          )
          return (
            <div key={i}>
              <div className="summaryTreatments">
                <h3 className="treatmentTitle">{title}</h3>
                <span>
                  {`${content} ${data.clickToLearn} `}
                  <a className="clickToLearn" href={link}>
                    {titleLower}
                  </a>
                  {`.`}
                </span>
              </div>
            </div>
          )
        })}
        <div className="summaryFooter">
          <div>
            <Button className="startOver quiz-button quiz-button-default quiz-button-round" variant="gray" shape="round" onClick={this.props.resetQuiz}>
              {data.startOver}
            </Button>
          </div>
          <div>
            <Button variant="blue" shape="round" onClick={event => window.location.href = '/clinic-finder.htm'}>
              {data.clinicFinder}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default SummaryPage
